import { TableColumn } from "../../models/tables/TableColumn";
import { COLUMN_TYPES } from "../COLUMN_TYPES";

export const ShippingLineColumns: TableColumn[] = [
    {
        name: "name", 
        displayName: "Name", 
        dataType: COLUMN_TYPES.string, 
        isEditable: true, 
        isEditableOnNew: true, 
        styles: {width: '30%'},
        reference: '',
        selectOptions: null
    },
    {
        name: "createdBy", 
        displayName: "Created By", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {width: '30%'},
        reference: '',
        selectOptions: null
    }
]


// WEBPACK FOOTER //
// ./src/app/contants/columns/columns.shipping.line.ts